export const sanitizeNumber = (v: string | number) => {
    if (typeof v == 'string') return parseInt(v.replace(/[^\d]*/g, ''));
    return v;
};

export const objectKeysValues = function* (obj: any): IterableIterator<any> {
    let key: string;
    for (key of Object.keys(obj)) {
        yield { key, value: obj[key] };
    }
};

interface fillObjectProps_Options {
    onlyExisting?: boolean;
    onFill(key: string, value: any): boolean | void;
}

const fillObjectProps_OptionsDefault = <fillObjectProps_Options>{
    onlyExisting: true,
    onFill: undefined,
};

export const fillObjectProps = (
    obj: any,
    props: any,
    options: fillObjectProps_Options = fillObjectProps_OptionsDefault
): any => {
    for (let { key, value } of objectKeysValues(props)) {
        if (Object.keys(obj).indexOf(key) > -1 || !options.onlyExisting) {
            if (options.onFill) {
                if (options.onFill(key, value) !== true) {
                    obj[key] = value;
                }
            } else {
                obj[key] = value;
            }
        }
    }
};
